import { Component } from 'react';
import { IconAlertTriangle } from './Icons';
import { ORANGE } from './theme';
import { reportError } from './monitoring';

const styles = {
  wrap: {
    minHeight: '100vh', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', textAlign: 'center',
    padding: '32px', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    background: 'var(--bg-tertiary)', color: 'var(--text-primary)',
  },
  emoji: { display: 'flex', justifyContent: 'center', color: ORANGE, marginBottom: '16px' },
  title: { fontSize: '1.4rem', fontWeight: 700, marginBottom: '8px' },
  message: { color: 'var(--text-secondary)', marginBottom: '24px', maxWidth: '420px' },
  button: {
    background: 'var(--color-secondary-hover)', color: 'var(--color-brand-white)', border: 'none', borderRadius: '10px',
    padding: '12px 28px', fontSize: '1rem', fontWeight: 600, cursor: 'pointer',
  },
};

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info.componentStack);
    // React catches render errors before they reach window.onerror, so the
    // SDK's global handler never sees them -- without this call, the crash
    // that blanks the whole page for a customer is the one error not reported.
    reportError(error, { componentStack: info.componentStack });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={styles.wrap}>
        <div style={styles.emoji}><IconAlertTriangle size={48} /></div>
        <h1 style={styles.title}>Something went wrong</h1>
        <p style={styles.message}>
          An unexpected error occurred. Reloading the page usually fixes this.
        </p>
        <button style={styles.button} onClick={() => window.location.reload()}>
          Reload page
        </button>
      </div>
    );
  }
}
